export * from './EntityPageContent';
